import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GenericLoaderService {
  isErrorOccured: boolean;
  showSpinner: boolean;
  errorText: string;
  constructor() { }
}
